import { asUTC } from '../../../utils/momentHelper';
import { HolidayEntry, HolidayResponse } from '../../api/v2';
import { Holiday } from '../../classbook/Holidays.interfaces';

export const holidayResponseToHoliday = (
  response: HolidayResponse,
): Holiday => {
  return {
    id: response.id,
    name: response.name ?? '',
    start: response.start ?? '',
    end: response.end ?? '',
  };
};

export const holidayToHolidayEntry = (holiday: Holiday): HolidayEntry => {
  return {
    start: asUTC(holiday.start),
    end: asUTC(holiday.end),
    name: holiday.name,
  };
};

export const holidayToHolidayResponse = (holiday: Holiday): HolidayResponse => {
  return {
    id: holiday.id,
    name: holiday.name,
    start: asUTC(holiday.start),
    end: asUTC(holiday.end),
  };
};
